import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Formik } from 'formik';
import { observer } from 'mobx-react';
import { useContext, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { storesContext } from '../../../../stores/storesContext';
import { errorToast, successToast } from '../../../helpers/toasts/ToastUtils';
import BlockForm from './BlockForm';

const CreateBlockModal = () => {
  const userStore = useContext(storesContext);
  const alcmStore = userStore.alcmStore;
  const propertiesStore = userStore.propertiesStore;

  const [open, setOpen] = useState(false);

  const show = () => setOpen(true);
  const hide = () => setOpen(false);

  const monitoringBlocks = alcmStore.monitoringBlocks;

  return (
    <>
      <Button
        className='px-3'
        variant='outline-primary'
        onClick={() => {
          show();
        }}
      >
        <FontAwesomeIcon icon={faPlus} size='sm' />
        {monitoringBlocks.length === 0 ? '  Add Block' : ''}
      </Button>
      <Modal backdrop='static' size='lg' show={open} onHide={() => hide()}>
        <Modal.Header closeButton>
          <Modal.Title>Create Block</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            validateOnChange={false}
            validateOnBlur={false}
            initialValues={{
              block_id: '',
              station_id: '',
              variety: null,
              g2_trap_catch_peak_date: null,
              g2_egg_peak_date: null,
              rootstock: null,

              geom: null
            }}
            validate={(values) => {
              const errors = {};
              if (!values.block_id) errors.block_id = 'Required';
              if (!values.station_id) errors.station_id = 'Required';
              return errors;
            }}
            onSubmit={async (values, actions) => {
              try {
                await alcmStore.createMonitoringBlock({
                  block_id: values.block_id,
                  property_id: propertiesStore.selectedProperty.id,
                  station_id: values.station_id,
                  variety: values.variety,
                  rootstock: values.rootstock,
                  g2_trap_catch_peak_date: values.g2_trap_catch_peak_date,
                  g2_egg_peak_date: values.g2_egg_peak_date,
                  geom: values.geom
                });
                await alcmStore.fetchMonitoringBlocks(
                  propertiesStore.selectedProperty.id
                );
                successToast('Block created successfully.');
                hide();
              } catch (err) {
                errorToast('Failed to create block.');
              } finally {
                actions.setSubmitting(false);
              }
            }}
          >
            {() => {
              return <BlockForm onCancel={hide} />;
            }}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default observer(CreateBlockModal);

